import "./buttonS1.css";
const ButtonS1 = ({
  text,
  clickButton,
  pos = "",
  variant = "filled",
  type = "button",
}) => {
  const buttonClassName =
    variant === "outline"
      ? "button-primary-button-primary button-primary-button-primary-outline "
      : "button-primary-button-primary ";
  const textClassName =
    variant === "outline"
      ? "button-primary-text CTAtext button-primary-text-outline"
      : "button-primary-text CTAtext";

  return (
    <>
      <button
        type={type}
        className={buttonClassName + pos}
        onClick={clickButton}
      >
        <span className={textClassName}>
          <span>{text}</span>
        </span>
      </button>
    </>
  );
};

export default ButtonS1;
